// don't import lengthUnits from here directly. import from ./units instead
import { defSimpleUnit, defAlias, defBaseUnit } from '../registry';

export const lengthUnits = [
  defBaseUnit('meter'),
  defSimpleUnit('micrometer', 'meter', 1e-6),
  defSimpleUnit('millimeter', 'meter', 1e-3),
  defSimpleUnit('centimeter', 'meter', 1e-2),
  defSimpleUnit('kilometer', 'meter', 1e3),

  // US customary system definitions, taken from
  // https://www.nist.gov/system/files/documents/2016/11/10/hb44-2017-web_final.pdf
  // Appendix C
  defSimpleUnit('mile', 'meter', 1609.344),
  defSimpleUnit('foot', 'meter', 0.3048),
  defSimpleUnit('yard', 'meter', 0.9144),
  defSimpleUnit('inch', 'foot', 1 / 12),
  defSimpleUnit('league', 'mile', 3),
  defSimpleUnit('pica', 'inch', 1 / 6),
  defSimpleUnit('point', 'inch', 1 / 72),

  // US survey units
  defSimpleUnit('link', 'meter', 0.201168),
  defSimpleUnit('rod', 'link', 25),
  defSimpleUnit('chain', 'rod', 4),
  defSimpleUnit('furlong', 'chain', 10),

  // Nautical units
  defSimpleUnit('nautical_mile', 'meter', 1852),
  defSimpleUnit('nautical_league', 'meter', 5556),
  defSimpleUnit('fathom', 'yard', 2),
  defSimpleUnit('cable', 'fathom', 120),

  // Astronomical units, ok this is a bit of a stretch
  defSimpleUnit('astronomical_unit', 'meter', 149597870700),
  defSimpleUnit('light_year', 'meter', 9.46073e15),
  defSimpleUnit('parsec', 'meter', 30.8567e15),

  // I mean, you never know
  defSimpleUnit('planck_length', 'meter', 1.616229e-35),
];

defAlias('km', 'kilometer');
defAlias('m', 'meter');
defAlias('cm', 'centimeter');
defAlias('mm', 'millimeter');
defAlias('micron', 'micrometer');
defAlias('miles', 'mile');
defAlias('nautical_miles', 'nautical_mile');
